import axios from "axios";

import Config from "../../config";

const actionUploadAvatar = (usuarioId, file) => {
    const formData = new FormData();
    formData.append('avatar', file);

    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/usuarios/${usuarioId}/upload-avatar`,
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
};

export default actionUploadAvatar;
